import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { ForwardRefForwardPropsComponent } from '../../types';

import { StyledProgressEllipsis } from './Progress.styles';
import type { ProgressProps } from './Progress.types';

const Ellipsis: ForwardRefForwardPropsComponent<ProgressProps> = forwardRef(function Ellipsis(
  { message, placement, ...restProps }: PropsWithoutRef<ProgressProps>,
  ref: ProgressProps['ref']
) {
  return (
    <StyledProgressEllipsis ref={ref} role='progressbar' placement={placement} {...restProps}>
      <span>
        <span />
        <span />
        <span />
      </span>
    </StyledProgressEllipsis>
  );
});

export default Ellipsis;
